import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LinkUserToContainerStationMutationVariables = Types.Exact<{
  user_uuid: Types.Scalars['ID'];
  container_station_id: Types.Scalars['ID'];
}>;


export type LinkUserToContainerStationMutation = { __typename?: 'Mutation', linkUserToContainerStation: boolean };


export const LinkUserToContainerStationDocument = gql`
    mutation LinkUserToContainerStation($user_uuid: ID!, $container_station_id: ID!) {
  linkUserToContainerStation(
    user_uuid: $user_uuid
    container_station_id: $container_station_id
  )
}
    `;
export type LinkUserToContainerStationMutationFn = Apollo.MutationFunction<LinkUserToContainerStationMutation, LinkUserToContainerStationMutationVariables>;

/**
 * __useLinkUserToContainerStationMutation__
 *
 * To run a mutation, you first call `useLinkUserToContainerStationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkUserToContainerStationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkUserToContainerStationMutation, { data, loading, error }] = useLinkUserToContainerStationMutation({
 *   variables: {
 *      user_uuid: // value for 'user_uuid'
 *      container_station_id: // value for 'container_station_id'
 *   },
 * });
 */
export function useLinkUserToContainerStationMutation(baseOptions?: Apollo.MutationHookOptions<LinkUserToContainerStationMutation, LinkUserToContainerStationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkUserToContainerStationMutation, LinkUserToContainerStationMutationVariables>(LinkUserToContainerStationDocument, options);
      }
export type LinkUserToContainerStationMutationHookResult = ReturnType<typeof useLinkUserToContainerStationMutation>;
export type LinkUserToContainerStationMutationResult = Apollo.MutationResult<LinkUserToContainerStationMutation>;
export type LinkUserToContainerStationMutationOptions = Apollo.BaseMutationOptions<LinkUserToContainerStationMutation, LinkUserToContainerStationMutationVariables>;